import React from 'react';
import { UseFormRegister, FieldError } from 'react-hook-form';
import { FieldConfig, SelectOption, Inputs } from './props';
import DynamicContactFormRow from './DynamicContactFormRow';

interface FieldComponentProps {
  fieldKey: string;
  fieldConfig: FieldConfig;
  register: UseFormRegister<Inputs>;
  error?: FieldError;
  getErrorMessage: (fieldKey: string) => string | undefined;
  hasError: (fieldKey: string) => FieldError | undefined;
}

export const HiddenField: React.FC<FieldComponentProps> = ({ fieldKey, fieldConfig, register }) => (
  <input
    type="hidden"
    defaultValue={fieldConfig.value}
    {...register(fieldKey)}
    id={fieldKey}
  />
);

export const TextField: React.FC<FieldComponentProps> = ({ fieldKey, fieldConfig, register, error, getErrorMessage, hasError }) => (
  <DynamicContactFormRow
    fieldKey={fieldKey}
    fieldConfig={fieldConfig}
    error={error}
    getErrorMessage={getErrorMessage}
    hasError={hasError}
  >
    <input
      className={`dynamic-form__input ${error ? 'dynamic-form__error' : ''}`}
      {...register(fieldKey, fieldConfig.validateOptions)}
      id={fieldKey}
      data-e2e={fieldKey}
    />
  </DynamicContactFormRow>
);

export const TextareaField: React.FC<FieldComponentProps> = ({ fieldKey, fieldConfig, register, error, getErrorMessage, hasError }) => (
  <DynamicContactFormRow
    fieldKey={fieldKey}
    fieldConfig={fieldConfig}
    error={error}
    getErrorMessage={getErrorMessage}
    hasError={hasError}
  >
    <textarea
      className={`dynamic-form__textarea ${error ? 'dynamic-form__error' : ''}`}
      {...register(fieldKey, fieldConfig.validateOptions)}
      id={fieldKey}
      data-e2e={fieldKey}
    />
  </DynamicContactFormRow>
);

export const SelectField: React.FC<FieldComponentProps> = ({ fieldKey, fieldConfig, register, error, getErrorMessage, hasError }) => {
  const defaultValue = fieldConfig.options?.find(option => option.selected)?.value;
  
  return (
    <DynamicContactFormRow
      fieldKey={fieldKey}
      fieldConfig={fieldConfig}
      error={error}
      getErrorMessage={getErrorMessage}
      hasError={hasError}
    >
      <select
        className={`dynamic-form__select ${error ? 'dynamic-form__error' : ''}`}
        {...register(fieldKey, fieldConfig.validateOptions)}
        id={fieldKey}
        defaultValue={defaultValue !== undefined ? String(defaultValue) : undefined}
        data-e2e={fieldKey}
      >
        {fieldConfig.options && fieldConfig.options.map((option: SelectOption) => (
          <option
            key={String(option.value)}
            className="dynamic-form__option"
            value={String(option.value)}
            disabled={option.disabled}
          >
            {option.title}
          </option>
        ))}
      </select>
    </DynamicContactFormRow>
  );
}; 